import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Card from 'components/atoms/Cards/Card/Card';
import FormStyles from 'styles/mixins/Form.styles';

const StyledActionCard = styled(Card)`
  position: relative;
  padding: ${props => props.theme.layout('1.5sp')} ${props => props.theme.layout('2sp')};
  background-color: unset;
  box-shadow: unset;
  border: 1px solid ${props => props.theme.property('palette.divider')};

  .ActionCard-content { 
    display: flex;
    gap: ${props => props.theme.layout('2sp')};
    position: relative;
    
    .ActionCard-logo {
      display: flex; 
      flex-direction: column;
      gap: ${props => props.theme.layout('0.25sp')};
      align-items: center;
      
      width: fit-content;
      .Icon {
        font-size: ${props => props.theme.fontSize(36)};
      }

      img {
        width: ${props => props.theme.layout(36)};
        height: ${props => props.theme.layout(36)};
      }
    }

    .ActionCard-info {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 1px;
      gap: ${props => props.theme.layout('0.75sp')};
      
      .ActionCard-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: fit-content;

        max-width: 100%;
      }
    }

    .ActionCard-details {
      display: flex;
      flex-direction: column;

      .ActionCard-detail {
        display: flex;
        overflow: hidden;

        &-label {
          min-width: ${props => props.theme.layout(88)};
          max-width: ${props => props.theme.layout(88)};
          
          &.Skeleton {
            transform: scale(0.95, 0.6);
          }
        }
        
        &-value {
          flex-grow: 1;
          overflow: hidden;
          color: ${props => props.theme.property('palette.text.secondary')};

          .ActionLink {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          &.ChipList {
            height: 100%;
            align-items: flex-start;
            align-content: center;
            padding-top: ${props => props.theme.layout(2)};
            column-gap: ${props => props.theme.layout('0.5sp')};
            row-gap: ${props => props.theme.layout('0.5sp')};
            
            > li {
              overflow: unset;
              display: inline-flex;
              align-items: flex-start;
            }
          }
        }
      }
    }
    
    .ActionCard-description {
      color: ${props => props.theme.property('palette.text.secondary')};
      
      &-wrapper {
        display: flex;
        flex-direction: column;
        position: relative;

        &:has(.readMore) {
          padding-bottom: ${props => props.theme.layout('2.5sp')};
          margin-bottom: -${props => props.theme.layout('0.5sp')};
        }
        
        .readMore {
          ${props => props.theme.font2Css('caption')};
          align-self: flex-end;
          position: absolute;
          bottom: 0;
        }
      }
    }

    .ActionCard-icon {
      display: flex;
      align-items: center;
    }

    .ActionCard-button {
      display: flex;
      align-items: start;
      position: absolute;
      right: 0;
    }
  }
  
  &.ActionCard-clampText {
    .ActionCard-description {
      overflow: hidden !important;
      .text {
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }

  ${FormStyles}
  ${ComponentStyles}
`;

StyledActionCard.propTypes = {
  theme: PropTypes.object
};

export default StyledActionCard;
